"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _reactLazyload = _interopRequireDefault(require("react-lazyload"));
var _lodash = require("lodash");
var _placeholderImg = _interopRequireDefault(require("../elements-image/placeholderImg"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
var BecomeAHost = function BecomeAHost(_ref) {
  var _ref$sectionTitle = _ref.sectionTitle,
    sectionTitle = _ref$sectionTitle === void 0 ? '' : _ref$sectionTitle,
    _ref$sectionSubtitle = _ref.sectionSubtitle1,
    sectionSubtitle1 = _ref$sectionSubtitle === void 0 ? '' : _ref$sectionSubtitle,
    _ref$sectionLinkUrl = _ref.sectionLinkUrl,
    sectionLinkUrl = _ref$sectionLinkUrl === void 0 ? '' : _ref$sectionLinkUrl,
    _ref$sectionLinkText = _ref.sectionLinkText,
    sectionLinkText = _ref$sectionLinkText === void 0 ? '' : _ref$sectionLinkText,
    _ref$items = _ref.items,
    items = _ref$items === void 0 ? [] : _ref$items;
  var imageDetails = (0, _lodash.get)(items, '0', {});
  var _imageDetails$content = imageDetails.contentCloudinaryId,
    contentCloudinaryId = _imageDetails$content === void 0 ? 'homepage_images/banners/concierge-banner' : _imageDetails$content;
  var backgroundStyle = {
    backgroundImage: "url(https://img.peerspace.com/image/upload/c_crop,g_custom/g_auto,q_auto,f_auto,fl_progressive/c_fill,w_1500/v1/".concat(contentCloudinaryId, ")")
  };
  return /*#__PURE__*/_react.default.createElement("div", {
    className: "BecomeAHost container"
  }, /*#__PURE__*/_react.default.createElement(_reactLazyload.default, {
    offset: 100,
    placeholder: _placeholderImg.default,
    once: true
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: "flex column middle img-rounded BecomeAHostBg",
    style: backgroundStyle
  }, /*#__PURE__*/_react.default.createElement("h2", {
    className: "title text-center"
  }, sectionTitle), /*#__PURE__*/_react.default.createElement("div", {
    className: "subtitle text-large margin-lg-left margin-lg-right"
  }, sectionSubtitle1), /*#__PURE__*/_react.default.createElement("a", {
    className: "btn btn-lg btn-primary",
    href: sectionLinkUrl
  }, sectionLinkText))));
};
BecomeAHost.propTypes = {
  sectionTitle: _propTypes.default.string,
  sectionSubtitle1: _propTypes.default.string,
  sectionLinkUrl: _propTypes.default.string,
  items: _propTypes.default.array
};
var _default = exports.default = BecomeAHost;